import { request } from "@/utils/remoteRequest";

export function getTree() {
  return request({
    url: "/depts/searchIsCorporationDeptTree",
    method: "post",
  });
}

export function getAuthRoleTree(data) {
  return request({
    url: "/menuRoleAuth/loadRoleAuthMenuTree",
    method: "post",
    data,
  });
}

export function getUserTree(data) {
  return request({
    url: "/authManage/initRoleAuthUserTree",
    method: "post",
    data,
  });
}

export function doSaveRoleAuthUsers(data) {
  return request({
    url: "/authManage/doSaveRoleAuthUsers",
    method: "post",
    data,
  });
}

export function doSaveMenus(data) {
  return request({
    url: "/menuRoleAuth/saveRoleMenu",
    method: "post",
    data,
  });
}
